import React, { useEffect, useState } from "react";
import { Outlet, useLocation, Link } from "react-router-dom";
import '../../Common.css';
import Header from "./Header";
import Sidebar from "./Sidebar";
import Footer from "./Footer";

const Layout = () => {
  const [isMiniMenu, setIsMiniMenu] = useState(
    localStorage.getItem("menu-state") === "mini"
  );
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [darkMode, setDarkMode] = useState(false);




  const location = useLocation(); // ✅ hook at top-level of component

  const generateBreadcrumb = () => {
    const pathnames = location.pathname.split("/").filter((x) => x);

    if (pathnames.length === 0) {
      return (
        <li className="breadcrumb-item active" key="home">
          Home
        </li>
      );
    }

    return pathnames.map((name, index) => {
      const routeTo = "/" + pathnames.slice(0, index + 1).join("/");
      const displayName = name.charAt(0).toUpperCase() + name.slice(1);

      // Only last segment is active
      const isLast = index === pathnames.length - 1;

      // First segment never active, last segment always active
      if (index === 0) {
        return (
          <li className="breadcrumb-item" key={routeTo}>
            {displayName}
          </li>
        );
      }

      return (
        <li
          className={`breadcrumb-item ${isLast ? "active" : ""}`}
          key={routeTo}
        >
          {isLast ? displayName : <Link to={routeTo}>{displayName}</Link>}
        </li>
      );
    });
  };
  const toggleSidebar = () => {
    const newState = !isMiniMenu;
    setIsMiniMenu(newState);
    if (newState) {
      document.documentElement.classList.add("minimenu");
      localStorage.setItem("menu-state", "mini");
    } else {
      document.documentElement.classList.remove("minimenu");
      localStorage.setItem("menu-state", "expand");
    }
  };

  const toggleMobileMenu = () => {
    const sidebar = document.querySelector(".nxl-navigation");
    if (!sidebar) return;

    const newState = !isMobileMenuOpen;
    setIsMobileMenuOpen(newState);

    if (newState) {
      sidebar.classList.add("mob-navigation-active");
    } else {
      sidebar.classList.remove("mob-navigation-active");
    }
  };

  const closeMobileMenu = () => {
    const sidebar = document.querySelector(".nxl-navigation");
    if (!sidebar) return;

    setIsMobileMenuOpen(false);
    sidebar.classList.remove("mob-navigation-active");
  };

  const toggleDarkMode = () => {
    const newMode = !darkMode;
    setDarkMode(newMode);
  };

  useEffect(() => {
    const theme = localStorage.getItem("theme");

    if (theme === "dark") {
      setDarkMode(true);
    }
  }, []);


  useEffect(() => {
    document.documentElement.classList.toggle("app-skin-dark", darkMode);
    localStorage.setItem("theme", darkMode ? "dark" : "light");
  }, [darkMode]);

  return (
    <div className="app-layout">
      <Header
        isMiniMenu={isMiniMenu}
        isMobileMenuOpen={isMobileMenuOpen}
        darkMode={darkMode}
        toggleSidebar={toggleSidebar}
        toggleMobileMenu={toggleMobileMenu}
        closeMobileMenu={closeMobileMenu}
        toggleDarkMode={toggleDarkMode}
      />

      <div className="layout-container">
        <Sidebar onMenuItemClicked={closeMobileMenu} />

        <div>
          <main className="nxl-container d-flex flex-column">
            <div className="nxl-content flex-grow-1">

              {/* Breadcrumb */}
              {/* <div className="page-header">
                <div className="page-header-left d-flex align-items-center">
                  <ul className="breadcrumb mb-0">{generateBreadcrumb()}</ul>

                </div>
              </div> */}
              <Outlet />

              {/* <div className="main-content">
                <div className="row">
                  <Outlet />
                </div>
              </div> */}
            </div>

            <Footer />
          </main>
        </div>
      </div>
    </div>
  );
};

export default Layout;